import { render, staticRenderFns } from "./GraphTournamentDerrotas.vue?vue&type=template&id=2b8ab552"
import script from "./GraphTournamentDerrotas.vue?vue&type=script&lang=js"
export * from "./GraphTournamentDerrotas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports